module.exports = __webpack_public_path__ + "static/media/03tr.3eb7e85d.svg";